import { InjectionToken } from '@angular/core';

export const WINDOW_OBJECT = new InjectionToken<Window>('windowObject');
